import { call, put, select, takeLatest, all, cancelled } from 'redux-saga/effects'
import { get, isEmpty } from 'lodash'

import {
  menusSucceeded,
  menusItemsSucceeded,
  menusItemsFailed,
  MENUS_REQUESTED,
  MENUS_ITEMS_REQUESTED,
  menusFailed,
} from '../actions/menus'
import { getSelectedMenusIds } from '../selectors/config'
import { getSelectedMenus, getCurrentMenu, getIsKiosk, getMenus, getMenusNeedReload, getStands } from '../selectors/menus'

import StadiumRemote from '../remote/stadiumRemote'

import { getPaymentType } from '../selectors/peripheral'
import { isNetworkError } from '../VNUtil/Errors'
import { setNetworkAvailable } from '../actions/config'

export function* fetchMenus(params) {
  const ignoreThrottle = params?.payload?.ignoreThrottle
  const allowRequest = yield select(getMenusNeedReload)
  const isKiosk = yield select((state) => getIsKiosk(state))

  if (!allowRequest && !ignoreThrottle && !isKiosk) {
    yield put(menusFailed())
    return
  }
  let payload

  const paymentType = yield select((state) => getPaymentType(state))
  if (isKiosk) {
    const menus = yield select(getSelectedMenus)
    if (isEmpty(menus)) {
      yield put(menusFailed())
      return
    }
    const standUuids = [...new Set(menus.map((menu) => menu.standUuid))]
    payload = { standUuids, paymentType }
  } else {
    const organizationName = yield select((state) => state?.config?.organizationName ?? '')
    const menu = yield select(getCurrentMenu)
    if (isEmpty(menu)) {
      yield put(menusFailed())
      return
    }
    const standUuids = [menu?.standUuid]
    payload = {
      organizationName,
      standUuids,
      paymentType,
    }
  }

  try {
    const result = yield call(StadiumRemote.fetchMenus, payload)
    if (isEmpty(result)) {
      yield put(menusFailed())
      return
    }
    yield put(menusSucceeded(result))
  } catch (error) {
    const previouslyFetchedMenus = {
      data: {
        menus: yield select(getMenus),
        stands: yield select(getStands),
      },
    }

    yield put(menusSucceeded(previouslyFetchedMenus))
  }
}

export function* getMenusItems() {
  try {
    const orgName = yield select((state) => get(state, 'config.organizationName', ''))
    const isKiosk = yield select(getIsKiosk)
    const menuUuids = yield select(getSelectedMenusIds)

    const result = yield all(menuUuids.map((menuUuid) => call(StadiumRemote.getPosMenu, menuUuid, orgName, isKiosk)))

    yield put(menusItemsSucceeded(result, isKiosk))
  } catch (error) {
    if (isNetworkError(error)) {
      yield put(setNetworkAvailable(false))
    }
    yield put(menusItemsFailed())
    // eslint-disable-next-line no-console
    console.log(error)
  } finally {
    if (yield cancelled()) {
      yield put(menusItemsFailed())
    }
  }
}

export function* watchGetMenus() {
  yield takeLatest(MENUS_REQUESTED, fetchMenus)
}

export function* watchGetMenusItems() {
  yield takeLatest(MENUS_ITEMS_REQUESTED, getMenusItems)
}
